import { Youtube } from './youtube';

export const Videos: React.FC = () => {
  return (
    <>
      <Youtube embedId="QLqNxJ_b6Bg" />
      <Youtube embedId="pQZLH1oQ53E" />
    </>
  );
};
